import { Control, Controller } from "react-hook-form";
import { CircularProgress, InputAdornment, ListItemIcon, MenuItem, StandardTextFieldProps, TextField, Stack, FormLabel, Typography, IconButton } from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useEffect, useState } from "react";
import React from "react";

import { NumberFormatValues, NumericFormat } from 'react-number-format';

export type ControlledTextFieldOption = {
    id: number
    descripcion: string
    icon?: React.ReactNode
}
export interface ControlledTextFieldProps<TOption = any> extends StandardTextFieldProps {
    control: Control<any>,
    options?: Array<TOption>,
    currency?: boolean,
    fixedDecimals?: boolean,
    textAlign?: CanvasTextAlign,
    firstOpDefault?: boolean,
    maxHeight?: number,
    selectNotNulleable?: boolean
    nullOptionLabel?: string,
    valueField?: keyof TOption,
    descriptionField?: keyof TOption,
    onlyOpenOnArrow?: boolean,
    numeric?: boolean,
    freeSolo?: boolean,
    labelSize?: string,
    optionPrefix?: string,
    optionSuffix?: string,
    min?: boolean, // para hacerlo minimo en tamanio
    saveFormattedValue?: boolean,

    percentage?: boolean,
    // phone?: boolean,
}


export const ControlledTextField = ({ size, type, selectNotNulleable, onlyOpenOnArrow, ...props }: ControlledTextFieldProps) => {
    const [open, setOpen] = useState<boolean>(false)

    const parseInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (props.numeric) {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
        }

        return e
    };

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField {...props}
                    sx={{ ...props.sx }}
                    size={size ?? 'small'}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        const event = parseInput(e);
                        if (props.select && event.target.value === '-1') {
                            onChange(null);
                        } else {
                            onChange(event);
                        }
                    }}

                    value={type === 'number' ? +value : (props.select ? (props.options && value != null ? value : 0) : value)}
                    type={type ?? 'text'}
                    error={!!error}
                    helperText={error && error.message}
                    SelectProps={{
                        ...(onlyOpenOnArrow ? {
                            IconComponent: () => null,
                            open: open,
                            onClose: () => setOpen(false)
                        } : {})
                    }}
                    InputLabelProps={{
                        shrink:
                            type === 'number'
                                ? value + 1
                                : value !== 0
                                    ? value ?? undefined
                                    : !props.select,
                        sx: {
                            fontSize: props.labelSize,
                        },
                        ...(props?.min && {
                            style: {
                                fontSize: '14px',
                                lineHeight: '1.2',
                            }
                        }),
                        ...props.InputLabelProps,
                    }}
                    InputProps={{
                        inputComponent: props.currency ? NumberFormatCustom as any : 'input',
                        inputProps: {
                            ...props.InputProps?.inputProps,
                            currency: props.currency,
                            style: { textAlign: props.textAlign },
                            prefix: props.prefix,
                            fixed: props.fixedDecimals,
                            saveFormattedValue: props.saveFormattedValue,
                            percentage: props.percentage,
                        },
                        endAdornment: (
                            <InputAdornment position='end' sx={{ position: 'absolute', right: 0 }}>
                                {(!props.options && props.select) ?
                                    <CircularProgress size={25} /> :
                                    (props.options && onlyOpenOnArrow && !props.disabled) &&
                                    <IconButton onClick={() => setOpen(open => !open)} disabled={props.disabled}>
                                        <ArrowDropDownIcon />
                                    </IconButton>
                                }
                            </InputAdornment>
                        ),
                        sx: {
                            '& > div': { alignContent: 'center !important', display: 'inline-flex !important' },
                            ...(onlyOpenOnArrow ? { pr: 0 } : {})
                        },
                        ...(props?.min && {
                            style: {
                                fontSize: '12px',
                                lineHeight: '1.2',
                                paddingTop: '6px',
                                paddingBottom: '6px',
                                paddingLeft: '0px',
                                height: '30px'
                            }
                        }),
                        ...props.InputProps
                    }}

                >
                    {(props.select && !selectNotNulleable) && <MenuItem value={'-1'} >{props.nullOptionLabel}</MenuItem>}
                    {

                        (props.options && props.select) &&
                        props.options.map((option) => (
                            <MenuItem key={option.id} value={props.valueField ? option[props.valueField] : option.id}>
                                <Stack direction={'row'} alignItems={'center'}>
                                    {option.icon && <ListItemIcon>{option.icon}</ListItemIcon>}
                                    {props.optionPrefix}{props.descriptionField ? option[props.descriptionField] : option.descripcion}{props.optionSuffix}
                                    {/* <Typography>
                                    </Typography> */}
                                </Stack>
                            </MenuItem>
                        ))
                    }
                </TextField>
            )}
        />
    )
}

export const ControlledTextFieldFilled = ({ /*helperText,*/ label, required, type, ...props }: ControlledTextFieldProps) => {

    // const theme = useTheme();
    // const classes = controlledTextFieldStyles(theme);

    return (
        <Controller
            control={props.control}
            name={props.name || ''}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Stack sx={{ width: '100%' }}>
                    <FormLabel

                    // className={
                    //     clsx(classes.labelFilled, { [classes.labelFilledDisabled]: props.disabled })
                    // }
                    >
                        <Stack direction="row"
                            justifyContent="flex-start"
                            spacing={1}
                        >
                            <>
                                {label}
                                <Typography color={'text.disabled'} ml={'4px'} fontSize={'0.9rem'}>{`${required ? "*" : ''}`}</Typography>
                            </>

                        </Stack>
                    </FormLabel>
                    <TextField
                        {...props}
                        variant="outlined"

                        // className={classes.textFilled}
                        // sx={{
                        //     ...classes.textFilled
                        // }}
                        size="small"
                        value={type === 'number' ? +value : !props.select ? value : (!props.options || !value ? 0 : value)}
                        onChange={onChange}
                        error={!!error}

                        // placeholder={props.placeholder || (props.phone ? '(11) 94444-2222' : undefined)}
                        placeholder={props.placeholder}
                        defaultValue={
                            props.defaultValue ? props.defaultValue :
                                !props.select ? value : (!props.options ? 0 : value)
                        }
                        SelectProps={{
                            MenuProps: {
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                            },
                        }}
                        InputProps={{
                            inputComponent: (props.currency || type === 'number') ? NumberFormatCustom as any : 'input',
                            inputProps: {
                                ...props.InputProps?.inputProps,
                                currency: props.currency,
                                style: { textAlign: props.textAlign },
                                prefix: props.prefix,
                                fixed: props.fixedDecimals,
                            },
                            endAdornment: (
                                <InputAdornment position='end'>
                                    {(!props.options && props.select) && <CircularProgress size={25} />}
                                </InputAdornment>
                            ),


                            ...props.InputProps
                        }}
                        InputLabelProps={{
                            shrink:
                                type === 'number' ? value + 1
                                    : value !== 0 ? value ?? undefined : !props.select,

                            ...props.InputLabelProps,
                        }}
                    >
                        {
                            ((props.select) && (!props.firstOpDefault)) &&
                            <MenuItem value={0}

                                // className={classes.menuItemSelect}
                                // sx={{
                                //     ...classes.menuItemSelect,
                                // }}
                                disableRipple
                            />
                        }
                        {
                            (props.options && props.select) &&
                            props.options.map((option) => (
                                <MenuItem key={option.id}
                                    value={option.id}

                                    // className={classes.menuItemSelect}
                                    // sx={{
                                    //     ...classes.menuItemSelect,
                                    // }}
                                    disableRipple
                                >
                                    {option.descripcion}
                                </MenuItem>
                            ))
                        }
                    </TextField>

                    {/* {error && <HelperInputText text={error.message} error />}

                        {(helperText && !error) && <HelperInputText text={helperText} />} */}
                </Stack>
            )}
        />
    )
};

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    currency?: boolean,
    percentage?: boolean,
    prefix?: string;
    suffix?: string;
    fixed?: boolean,
    saveFormattedValue?: boolean,
}

const NumberFormatCustom = React.forwardRef<typeof NumericFormat, CustomProps>(
    function NumberFormatCustom(props, ref) {
        const { onChange, ...other } = props;
        const prefix: string | undefined = props?.prefix || undefined;
        const suffix: string | undefined =
            props?.percentage ? '%' : undefined

        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values:NumberFormatValues) => {
                    onChange({
                        target: {
                            name: props.name,
                            // value: values.value,
                            value: props.saveFormattedValue ? values.formattedValue : values.value,
                        },
                    });
                }}
                
                thousandSeparator="."
                decimalSeparator=","
                valueIsNumericString={!props.saveFormattedValue}
                decimalScale={5}
                fixedDecimalScale={props.fixed}
                prefix={prefix ? `${prefix} ` : undefined}
                suffix={suffix}
            />
        );
    },
);
